import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import {
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TextareaAutosize,
  TextField,
  Typography,
} from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import "./modal.css";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

// import DialogTitle from '@material-ui/core/DialogTitle';
// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

export default function DieselInfoModal({
  infoModalClose,
  openAlert,
  title,
  data,
}) {
  // const [isShow,setIsSHow]=React.useState(false)
  console.log(title, data);
  let roleObj = {
    actionBy: "",
    quantity: "",
    date: "",
    remarks: "",
  };

  return (
    <div>
      <Dialog
        //className='Dialogbox'

        open={openAlert}
        onClose={infoModalClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid>{title}</Grid>
            <Grid>
              <IconButton aria-label="close" onClick={infoModalClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableCell>Action By</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Remarks</TableCell>
                </TableHead>
                {data && (
                  <TableBody>
                    <TableCell>{data.actionBy}</TableCell>
                    <TableCell>{data.quantity}</TableCell>
                    <TableCell>{data.date}</TableCell>
                    <TableCell>{data.remarks}</TableCell>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleAlertClose} color="primary" variant="outlined">
            {Type == "createRequeste"
              ? "Cancle Request "
              : Type == "Reject"
              ? "Cancle Rejected"
              : Type == "Approve"
              ? "Reject"
              : Type == "Issue"
              ? "Cancle"
              :Type == "createIssue"?"Cnacle":""}
          </Button> */}

          <Button onClick={infoModalClose} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
